import { useEffect } from "react"
import { useLocation, Navigate } from "react-router-dom"

import UserPanelMain from "../Account_Panels/User/UP_Main"
import AdminPanelMain from "../Account_Panels/Admin/AP_Main"

import { useAuth } from "../context/userContext"
import CartContext from "../context/cartContext"
import { useContext } from "react"

const AccountPage = () => {
  const location = useLocation()
  const tab = location.state?.tab || "home"

  const { user } = useAuth()
  const { setCart } = useContext(CartContext)
  /* ---------- Sync cart ---------- */
  useEffect(() => {
    if (user?.cart) {
      setCart(user.cart)
    }
  }, [user, setCart])

  /* ---------- Loading ---------- */
  if (user === undefined) return null

  /* ---------- Auth ---------- */
  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!user.email_verified) {
    return <Navigate to="/verify-email" replace />
  }

  /* ---------- Role routing ---------- */
  // Admins edit the sign-up form (Admin → Sign Up); they never fill it in.
  if (user.account_type === "admin") {
    return <AdminPanelMain user={user} />
  }

  return <UserPanelMain tab={tab} user={user} />
}

export default AccountPage
